import { useState } from 'react'
import Modal from 'react-modal'
import admitted from '../../assets/docs/admitted.pdf' 
import styled from 'styled-components'
import {useHistory} from 'react-router-dom'
import {devices} from '../../components/MediaQuerys/BreakpointsAndDevices'

import {HeaderContainer, NavbarContainer} from '../container/Container'
import LogoImage from '../../assets/images/logo.svg' 
import LogoUpn from '../../assets/images/LogoUpn.svg'
import LogoBogota from '../../assets/images/LogoBogota.svg'

Modal.setAppElement('#root')

// Header
const Logo = styled.img`
    width: auto;
    height: 5em;
    display: block;
    @media only screen and ${devices.mobileS} {
        height: 2.5em;
        width: auto;
    }
    @media only screen and ${devices.mobileM} {
        height: 3em;
        width: auto;
        
    }
    @media only screen and ${devices.tablet} {
        height: 5em;
        width: auto;
    }
    @media only screen and ${devices.laptop}{
        height: 5em;
        width: auto;
        
    }
    @media only screen and ${devices.laptopL}{
        height: 5em;
        width: auto;
        

    }

`

const Logo2 = styled.img`
    width: auto;
    height: 5em;
    display: block;
    @media only screen and ${devices.mobileS} {
        display: none;
        
    }
    @media only screen and ${devices.mobileM} {
        display: none;
        
    }
    @media only screen and ${devices.tablet} {
        display: block;
    }
    @media only screen and ${devices.laptop}{
        display: block;
        
    }
    @media only screen and ${devices.laptopL}{
        display: block;
        

    }
`
const Title = styled.h1`
    font-family: 'Damion-Regular';
    font-size: 50px;
    font-weight: 400;
    color: whitesmoke;
    display: none;
    @media only screen and ${devices.laptop}{
        display: contents;
    }
    @media only screen and ${devices.tablet} {
        display: contents;
    }
`

export const Header = () => {
    const history = useHistory()
    return (
        <HeaderContainer>
            <Logo 
                src={LogoUpn} 
                style={{
                    width:'auto',
                    // height:'5em',
                    cursor:'pointer'
                }}
                onClick={()=> history.push('/')}/>
            <Logo2 src={LogoImage}
            style={{
                // display: "none",
            }}
            />
            <Title>Formación BOSA 2022</Title>
            <Logo 
                src={LogoBogota} 
                style={{
                    width:'auto', 
                    // height:'5em',
                    backgroundColor:'whitesmoke',
                    padding: '10px',
                    // marginTop:'0px',
                    borderBottomLeftRadius:'20px',
                    borderBottomRightRadius:'20px'
                    
                }}/>
        </HeaderContainer>
    )
}
const NavItem = styled.button`
    background-color: ${props => props.color};
    border: 0;
    width: 260px;
    height: 40px;
    cursor: pointer;
    transition: all 0.2s ease-in;
    border-radius: 0.2em;
    &:hover{
        height: 60px;
        width: 285px;
        transition: all 0.2s ease-in;
        background-color: #FF7C66;
        font-weight: bold;
    }
`
const NavText = styled.p`
    color: whitesmoke;
    font-family: 'Montserrat-Light';
    font-size: 18px;
`
const customStyles = {
    content:{
        top:'50%',
        left:'50%',
        rigth:'auto',
        bottom:'auto',
        marginRight: '-50%',
        transform:'translate(-50%,-50%)',
        width: '70rem',
        height: 'auto',
        boxShadow:' 2px 2px 10px -9px rgba(0, 0, 0, .3)',
        background: 'rgba(255, 255, 255, 0.6)',
        backdropFilter: 'blur(5px)',
        
    }
}
const PDFFile = styled.embed`
    opacity: 1;
    width:67rem; 
    height:700px;
    transition: all 5s ease-in-out;
    
`
// Navbar
export const Navbar = ()=>{
    const [modalIsOpen, setmodalIsOpen] = useState(false)
    const openModal = ()=>{
        setmodalIsOpen(true)
    }
    const closeModal = ()=>{
        setmodalIsOpen(false)
    }
    return (
        <>
        <NavbarContainer>
            <NavItem color="#D45FEE">
                <NavText onClick={openModal}>Listado de inscritos</NavText>    
            </NavItem>
        </NavbarContainer>
        <Modal
            isOpen={modalIsOpen}
            onRequestClose={closeModal}
            style={customStyles}
            closeTimeoutMS={200}
            overlayClassName='modal-fondo'>
            <PDFFile 
                src={admitted}
                scale={100}
                frameBorder="0"></PDFFile>
        </Modal>
        </>
    );
}
